'use client';

import React from 'react';
import { ComponentContainer } from '@/components/atoms/ComponentContainer/ComponentContainer';
import { useTranslations } from 'next-intl';
import * as Styled from './ObsoleteProjectWarning.styled';
import { Typography } from '@/components/atoms/Typography/Typography';

interface IObsoleteProjectWarningProps {
  year: string;
}

export const ObsoleteProjectWarning: React.FC<IObsoleteProjectWarningProps> = ({
  year,
}) => {
  const translations = useTranslations('project');
  const t = translations.raw('obsolete') as {
    title: string;
    text: string;
  };

  const title = t.title
    .replace('--year--', year)
    .replace('--span--', '<span')
    .replace('--/span--', '</span>');

  return (
    <Styled.ModalContainer>
      <ComponentContainer width={'main'} marginBottom={'none'} isProject={true}>
        <Styled.ContainerObsoleteMessage>
          <Typography text={title} as={'p'} />
          <Typography text={t.text} as={'p'} className="text-obsolete" />
        </Styled.ContainerObsoleteMessage>
      </ComponentContainer>
    </Styled.ModalContainer>
  );
};
